import React, { useState } from "react";
import { Navbar, Footer, Sidebar } from "../medicalcomponents";

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => setIsOpen((prev) => !prev);

  const NAVBAR_HEIGHT = 60;
  const SIDEBAR_WIDTH = isOpen ? 260 : 85;

  return (
    <div style={{ minHeight: "100vh", background: "#f4f6f9" }}>

      {/* NAVBAR */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: NAVBAR_HEIGHT,
          zIndex: 2000,
          background: "#fff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <Navbar toggleSidebar={toggleSidebar} />
      </div>

      {/* SIDEBAR (starts EXACTLY below navbar) */}
      <div
        style={{
          position: "fixed",
          top: NAVBAR_HEIGHT,
          left: 0,
          width: SIDEBAR_WIDTH,
          height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
          zIndex: 1500,
          transition: "width 0.3s ease",
          overflow: "hidden",
        }}
      >
        <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
      </div>

      {/* MAIN CONTENT */}
      <div
        style={{
          marginLeft: SIDEBAR_WIDTH,
          marginTop: NAVBAR_HEIGHT,
          transition: "all 0.3s ease",
        }}
      >
        <main style={{ padding: "20px" }}>
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "20px",
              minHeight: "calc(100vh - 120px)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            }}
          >
            {children}
          </div>
        </main>

        <Footer />
      </div>

    </div>
  );
};

export default Layout;